module.exports = __webpack_public_path__ + "img/feature-icon1.e0980c0.svg";